<template>
  <v-dialog v-model="dialog" :max-width="options.width" @keydown.esc="cancel()" persistent>
    <v-card>
      <v-toolbar dark :color="options.color">
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-5" v-show="!!message">{{ message }}</v-card-text>
      <v-card-text v-if="info" class="pt-0 pb-3">
        <v-alert type="info" text dense class="mb-0">{{ info }}</v-alert>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions :class="$vuetify.breakpoint.xsOnly && 'flex-column-reverse'">
        <v-spacer></v-spacer>
        <v-btn :block="$vuetify.breakpoint.xsOnly" text @click.native="cancel()">{{ options.cancel || $t('cancel') }}</v-btn>
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          :class="$vuetify.breakpoint.xsOnly && 'mb-2'"
          :color="options.color"
          v-if="options.agree"
          @click.native="agree()"
          >{{ options.agree }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Vuetify Confirm Dialog component
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {});
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open;
 * }
 */
export default {
  name: 'ConfirmDialog',

  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      info: null,
      title: null,
      options: {
        color: 'primary',
        agree: this.$t('yes'),
        cancel: null,
        width: 390,
      },
    };
  },
  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.info = (options && options.info) || null;
      // Painiketekstit ja leveys nollataan aina, ettei edellisen dialogin arvo jää voimaan.
      this.options = Object.assign(this.options, { agree: this.$t('yes'), cancel: null, width: 390 }, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>
